export function invalidTacticUpdateParser(notificationDetails, parsedObject) {
  if (!parsedObject) {
    parsedObject = {
      tacticName: null,
      errorType: 'INVALID_TACTIC_UPDATE',
    };
  }
  if (notificationDetails) {
    parsedObject.tacticName = notificationDetails.tacticName ?? null;
  }
  return parsedObject;
}
